import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificateToolService {
  dynamicFieldList: BehaviorSubject<[]> = new BehaviorSubject([]);
  backgrounds: [] = [];
  uncheckedElements: any = [];
  newDynamicElement = {
    elementType: 'text',
    contentEditable: false,
    isContentEditing: false,
    text: '',
    fieldName: '',
    sampleValue: '',
    fontSize: 20,
    lineHeight: 20,
    width: 'auto',
    fontFamily: "Barlow",
    fontColor: '#000',
    display: true,
    bold: false,
    transform: 'lowercase',
    fontWeight: '500',
    underline: false,
    italic: false,
    align: 'left',
    opacity: 1,
    rotate: 0,
    position: {
      top: 10,
      left: 20,
      tTop: 0,
      tLeft: 0
    }
  }

  selectedField: EventEmitter<any> = new EventEmitter<any>();


  templateData = {
    backgroundImage: '',
    fontFamilyCdn: 'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Bilbo+Swash+Caps&family=Caveat:wght@400..700&family=DM+Serif+Text:ital@0;1&family=Dancing+Script:wght@400..700&family=Fleur+De+Leah&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Kaushan+Script&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Nunito:ital,wght@0,200..1000;1,200..1000&family=Playball&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Qwigley&family=Roboto:ital,wght@0,100..900;1,100..900&family=Sail&family=Sansita+Swashed:wght@300..900&family=Six+Caps&family=Tangerine:wght@400;700&display=swap',
    dynamicElements: [],
    signature: {
      link: '',
      elementType: 'image',
      width: 100,
      display: true,
      opacity: 1,
      rotate: 0,
      position: {
        top: 50,
        left: 50
      }
    },
    width: 1500,
    height: 1061,
    aspectRatio: ''
  }

  defaultTemplateFormat = {
    backgroundImage: '',
    dynamicElements: [],
    width: 1500,
    height: 1061,
    signature: {
      elementType: 'image',
      link: '',
      display: true,
      opacity: 1,
      rotate: 0,
      position: {
        top: 31.99,
        left: 90.5
      }
    },
    aspectRatio: ''
  }

  constructor() {

    // get selected field
    this.dynamicFieldList.subscribe((res) => {
      console.log("ressubscribe", res);
      // if(res){
      //   if(res.some((item:any) => item.isSelected)){
      //     const temp = {...this.newDynamicElement}
      //     console.log("temp", temp);
      //     this.templateData.dynamicElements.push(this.newDynamicElement)
      //     console.log("this.templateData.dynamicElements", this.templateData.dynamicElements);
      //   }
      // }
    })


    this.selectedField.subscribe((res) => {
      if (res.title) {
        // if(res.isSelected){

        const styledElement = this.uncheckedElements.filter((item) => item.text == res.title)

        if (!styledElement?.length) {
          const tempField = JSON.parse(JSON.stringify(this.newDynamicElement))
          tempField.text = res.createField || res.title;
          tempField.fieldName = `{{${res.title}}}`;


          if (this.templateData.dynamicElements.length != 0)
            tempField.position.top = (this.templateData.dynamicElements.length * 4);
          else
            tempField.position.top = 5


          if (tempField.text)
            this.templateData.dynamicElements.push(tempField);

        } else {
          const tempField = JSON.parse(JSON.stringify(styledElement[0]))
          this.templateData.dynamicElements.push(tempField);
        }
        // }else{
        // const index = this.templateData.dynamicElements.findIndex((item) => item.text == res.title);      
        // this.uncheckedElements.push(this.templateData.dynamicElements[index]);

        // this.templateData.dynamicElements.splice(index, 1);

        // console.log("Remove", this.templateData.dynamicElements);
        // }
      }
      console.log("dynamicElementsdynamicElements", this.templateData.dynamicElements);

    })

  }


  emitData(data: any): void {
    this.selectedField.emit(data);
  }

}
